import { render, staticRenderFns } from "./DatenschutzAnfrageModal.vue?vue&type=template&id=0eac1469"
import script from "./DatenschutzAnfrageModal.vue?vue&type=script&lang=js"
export * from "./DatenschutzAnfrageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports